import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import './walletSaldo.css'
import { Skeleton, Button } from 'antd'
import { loadBalance } from '../../redux-flow/actions/wallet_btc'
import { loadBrlBalance } from '../../redux-flow/actions/wallet_brl'
import { connect } from 'react-redux'
import moment from 'moment'
import { getInfoLocalStorage } from '../../utils/api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons'
import { ReactComponent as BRL } from '../../images/wallet/brl_real.svg'
import { ReactComponent as BTC } from '../../images/wallet/btc_bitcoin.svg'

const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', { 
    style: 'currency', 
    currency: 'BRL' 
  }).format(value/100).replace('R$', '')
}

const WalletSaldo = ({ 
  userid, 
  onLoad, 
  getBrl, 
  brlBalance, 
  isLoading, 
  isLoadingW, 
  type 
}) => {
  const [btcActive, setBtcActive] = useState(true)
  const [updatedAt, setUpdatedAt] = useState(getInfoLocalStorage().updatedAT)
  const isDesktop = window.innerWidth > 1024
  const btcBalance = getInfoLocalStorage().btcBalance

  useEffect(() => {
    if (userid) {
      if (onLoad && (btcBalance == null || btcBalance === undefined)) {
        onLoad(userid)
      }
      if (getBrl) {
        getBrl(userid)
      }
    }
    setUpdatedAt(getInfoLocalStorage().updatedAT)
  }, [userid, onLoad, getBrl, btcBalance])

  const LastUpdatedInfo = () => (
    <small className="tituloSaldo">
      Saldo atualizado em {moment(updatedAt).format("DD/MM/YYYY HH:mm")}.{' '}
      <FontAwesomeIcon 
        onClick={() => onLoad(userid)} 
        icon={faRedoAlt} 
        style={{color: '#2F2E2E', cursor: 'pointer'}} 
      />
    </small>
  )

  return (
    <>
      {isDesktop ? (
        <Row>
          <Col md={4} className="colSaldoBrl">
            <div className='d-flex'>
              <div className='ml-3'>
                <div className="tituloSaldo">Saldo R$</div>
                {isLoading ? 
                  <Skeleton active title={false} paragraph={{rows: 1, width: 100}} /> :
                  <div className="valorSaldo d-flex">
                    <BRL className="iconeSaldo" />{formatCurrency(brlBalance)}
                  </div>
                }
              </div>
            </div>
          </Col>
          <Col md={8}>
            <div className='d-flex'>
              <div className='ml-3'>
                <div className="tituloSaldo">Saldo BTC</div>
                {isLoadingW ? 
                  <Skeleton active title={false} paragraph={{rows: 2, width: 200}} /> :
                  <div className="saldoBtcWrapper">
                    <div className="valorSaldo d-flex">
                      <BTC className="iconeSaldoBTC"/>{btcBalance} BTC
                    </div>
                    <LastUpdatedInfo />
                  </div>
                }
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col md={12}>
            <div className={`tituloSaldo ${type === 'brl' || type === 'btc' ? 'text-center' : ''}`}>
              Saldo
            </div>
          </Col>
          <Col md={12}>
            {type === 'brl' ? (
              isLoading ? 
                <Skeleton active title={false} paragraph={{rows: 2}} /> :
                <div className="valorSaldo text-center">R$ {formatCurrency(brlBalance)}</div>
            ) : type === 'btc' ? (
              isLoadingW ? 
                <Skeleton active title={false} paragraph={{rows: 2}} /> : 
                <div className="valorSaldo text-center">
                  {btcBalance} BTC<br />
                  <LastUpdatedInfo />
                </div>
            ) : (
              <div className="d-flex align-items-start">
                {btcActive ? (
                  <div className="saldoBtcWrapper">
                    {isLoadingW ? 
                      <Skeleton active title={false} paragraph={{rows: 2}} /> : 
                      <>
                        <div className="valorSaldo">{btcBalance} BTC</div>
                        <LastUpdatedInfo />
                      </>
                    }
                  </div>
                ) : (
                  <div className="valorSaldo h6 pt-1">R$ {formatCurrency(brlBalance)}</div>
                )}
                <div className="switchSaldo d-flex justify-content-between">
                  <Button 
                    id="btc" 
                    onClick={() => setBtcActive(true)} 
                    className={`pt-1 ${btcActive ? 'saldoActive' : ''}`}
                  >
                    btc
                  </Button>
                  <Button 
                    id="brl" 
                    onClick={() => setBtcActive(false)} 
                    className={`pt-1 ${!btcActive ? 'saldoActive' : ''}`}
                  >
                    BRL
                  </Button>
                </div>
              </div>
            )}
          </Col>
        </Row>
      )}
      {(type !== 'btc' && type !== 'brl') && <hr className='linhaHorizontal'/>}
    </>
  )
}

const mapStateToProps = state => ({
  isLoading: state.wallet_brl.isLoading,
  isLoadingW: state.wallet_btc.isLoading,
  userid: state.login.userid,
  brlBalance: state.wallet_brl.brlBalance,
})
      
const mapDispatchToProps = dispatch => ({
  onLoad: id => {
    dispatch(loadBalance(id))
  },
  getBrl: (id) => {
    dispatch(loadBrlBalance(id))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(WalletSaldo)